import { Button, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CheckEmailExist } from "../../Auth/Helper";
import Swal from "sweetalert2";
import { emailRegex, validateEmail } from "../../../Utils/validation";
import { useCommonUserProvider } from "../../../Providers/Common/User";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import { useNavigate, useParams } from "react-router-dom";
import { useCommonJobProvider } from "../../../Providers/Common/Jobs";

const AddUser = () => {
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { id } = useParams();
  const {
    getRoles,
    roles,
    setRoles,
    addChildUser,
    getUserDetails,
    updateChildUser,
  } = useCommonUserProvider();
  const { fetchAllProjects, allProjects } = useCommonJobProvider();
  const navigate = useNavigate();
  const [user, setUser] = useState({});
  const [editForm, setEditForm] = useState(id);
  const [emailUsed, setEmailUsed] = useState(false);
  const [projects, setProjects] = useState([]);
  const [toggle, setToggle] = useState(false);

  const checkEmailUsed = (email) => {
    if (process.env.REACT_APP_BASE_URL === "https://dev.api.prolegion.com") {
      if (
        email.split("@")[1] === "yopmail.com" ||
        email.split("@")[1] === "test.com"
      ) {
        Swal.fire("Invalid Email!", "Please enter a correct email...", "error");
      }
    }

    CheckEmailExist({ email: email }).then((res) => {
      setEmailUsed(res?.data?.status);
    });
  };

  useEffect(() => {
    fetchAllProjects();
    if (id) {
      (async () => {
        const userDetails = await getUserDetails(id);
        console.log(userDetails);
        reset({
          firstName: userDetails.prolegionUserDetails?.firstName,
          lastName: userDetails.prolegionUserDetails?.lastName,
          email: userDetails.prolegionUserDetails?.email,
        });
        setRoles(userDetails.keycloakUserRoleDetails);
        setUser(userDetails);
        setToggle(!toggle);
      })();
    } else {
      getRoles();
    }
  }, []);

  useEffect(() => {}, [toggle, user, editForm]);

  useEffect(() => {
    if (editForm) {
      const temp = allProjects?.filter((project) =>
        user.keycloakUserDetails?.attributes?.projects?.includes(project.id)
      );
      setProjects(temp);
    }
  }, [allProjects, toggle, user]);

  const handleAdministratorAccess = (e) => {
    if (e.target.checked) {
      let tempRoles = roles;
      roles.forEach((role) => {
        role.isSelected = true;
        role.child.forEach((role) => (role.isSelected = true));
      });
      setRoles(tempRoles);
    } else {
      let tempRoles = roles;
      roles.forEach((role) => {
        role.isSelected = false;
        role.child.forEach((role) => (role.isSelected = false));
      });
      setRoles(tempRoles);
    }
    setToggle(!toggle);
  };

  const handleChildCheckboxChange = async(e, parentIndex, childIndex) => {
    if (e.target.checked) {
      let tempRoles = roles;
      const childs = await getRoles(tempRoles[parentIndex].child[childIndex].name);
      tempRoles[parentIndex].child[childIndex].isSelected = true;
      tempRoles[parentIndex].child.forEach((role)=> {
        if(childs.includes(role.id)){
          role.isSelected=true
        }
      })
        if(tempRoles[parentIndex].child.every((role)=> role.isSelected)){
          tempRoles[parentIndex].isSelected = true;
        }
        setRoles(tempRoles);
      } else {
        let tempRoles = roles;
        const childs = await getRoles(tempRoles[parentIndex].child[childIndex].name);
        tempRoles[parentIndex].child[childIndex].isSelected = false;
        tempRoles[parentIndex].child.forEach((role)=> {
          if(childs.includes(role.id)){
            role.isSelected=false
          }})
          tempRoles[parentIndex].isSelected = false;
          setRoles(tempRoles);
        }
  };

  const onSubmit = async(data) => {
    if (editForm) {
      const subroles = [];
      roles.forEach((role) => {
        if (role.isSelected) {
          subroles.push({ id: role.id, name: role.name });
        } else {
          role.child.forEach((role) => {
            if (role.isSelected)
              subroles.push({ id: role.id, name: role.name });
          });
        }
      });
      if (
        updateChildUser(user.prolegionUserDetails.id, {
          ...data,
          newRoles: subroles,
          resourceIds: projects.map((project) => project.id),
        })
      ) {
        navigate("/dashboard/settings");
      }
    } else {
      if (!emailUsed) {
        const subroles = [];
        roles.forEach((role) => {
          if (role.child.every((subRole) => subRole.isSelected)) {
            subroles.push({ id: role.id, name: role.name });
          } else {
            role.child.forEach((role) => {
              if (role.isSelected)
                subroles.push({ id: role.id, name: role.name });
            });
          }
        });
        const result = await addChildUser({
          ...data,
          subroles: subroles,
          permissions: projects.map((project) => project.id),
        });
        if(result){
          navigate("/dashboard/settings");
        }
      } else {
        Swal.fire("", "Email already exists", "info");
      }
    }
  };

  return (
    <div className="py-4 px-8 font-[Roboto] bg-white rounded-lg shadow-md shadow-gray-400">
      <h1 className="text-2xl font-semibold pt-2" style={{ color: "#2EBAA3" }}>
        {editForm ? "Edit" : "Add"} User
      </h1>
      <br />
      <form onSubmit={handleSubmit(onSubmit)}>
        <h1 className="text-base font-semibold text-[#2EBAA3]">
          Personal Details
        </h1>
        <div className="grid grid-cols-2 gap-5 p-4">
          <div>
            <TextField
              className="pt-2"
              id="outlined-basic"
              InputLabelProps={{ shrink: true }}
              {...register("firstName", { required: true })}
              label="First Name"
              variant="outlined"
              fullWidth
            />
          </div>
          <div>
            <TextField
              className="pt-2"
              id="outlined-basic"
              InputLabelProps={{ shrink: true }}
              {...register("lastName", { required: true })}
              label="Last Name"
              variant="outlined"
              fullWidth
            />
          </div>
          <div>
            <TextField
              className="pt-2"
              id="outlined-basic"
              {...register("email", { pattern: emailRegex })}
              label={"Email ID"}
              InputLabelProps={{ shrink: true }}
              error={errors?.email ? true : false}
              disabled={editForm ? true : false}
              onBlur={(e) => {
                checkEmailUsed(e.target.value);
              }}
              variant="outlined"
              fullWidth
            />
            {
              errors?.email && errors?.email?.type === "required" ?
                <h4 className="text-red-600 text-xs pt-2 pb-4">
                  Email is required
                </h4>
              : errors?.email && errors?.email?.type === "pattern" ?
                <h4 className="text-red-600 text-xs pt-2 pb-4">
                  Invalid Email
                </h4>
              : null
            }
            {emailUsed ? (
              <h4 className="text-red-600 text-xs pt-2 pb-4">
                Email is already used
              </h4>
            ) : (
              " "
            )}
          </div>
        </div>
        <br />
        <h1 className="text-base font-semibold text-[#2EBAA3]">Permissions</h1>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => handleAdministratorAccess(e)}
              checked={roles.every((role) => role.isSelected)}
              inputProps={{ "aria-label": "controlled" }}
            />
          }
          label={"Administrator Access"}
        />
        <div className="grid grid-cols-2 gap-6 p-4">
          {roles.map((role, parentIndex) => {
            return (
              <div className="flex gap-5">
                <div className="flex-none w-24">
                  <h1 className="font-semibold py-2">{role.name}</h1>
                </div>
                <div className="flex-1">
                  <FormGroup>
                    {role.child.map((child, childIndex) => {
                      return (
                        <FormControlLabel
                          control={
                            <Checkbox
                              inputProps={{ "aria-label": "controlled" }}
                              checked={
                                roles[parentIndex].child[childIndex].isSelected
                              }
                            />
                          }
                          onChange={(e) =>
                            handleChildCheckboxChange(
                              e,
                              parentIndex,
                              childIndex
                            )
                          }
                          label={child.name}
                        />
                      );
                    })}
                  </FormGroup>
                </div>
              </div>
            );
          })}
        </div>
        <br />
        <h1 className="text-base font-semibold text-[#2EBAA3]">Projects</h1>
        <div className="p-4">
          <Autocomplete
            multiple
            id="tags-standard"
            options={allProjects}
            getOptionLabel={(project) => project.title}
            value={projects}
            onChange={(e, v) => setProjects(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Projects"
                placeholder="Search"
              />
            )}
          />
        </div>
        <div className="text-right pt-7">
          <Button
            variant="contained"
            type="submit"
            style={{ color: "#FFFFFF" }}
          >
            Submit
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
